export function isPlu(plu: string) {
  return Number(plu) && plu?.length > 2 && plu.length < 6;
}

export function isNSC2(upc: string) {
  if (!Number(upc)) return false;

  if (upc.length === 13 && (upc.startsWith('2') || upc.startsWith('02')))
    return true;
  if (upc.length === 12 && upc.startsWith('2')) return true;
  if (
    upc.length === 11 &&
    upc.startsWith('2') &&
    upc.substring(6, 11) === '00000'
  )
    return true;

  return false;
}

export function getAreAllNSC2Barcodes(upcs: string[] | undefined) {
  return upcs?.every((upc: string) => isNSC2(upc) || isPlu(upc)) || true;
}

export function getDoesBarcodeMatch(upcs: string[], matchingBarcode: string) {
  if (!upcs?.length) return true;

  return upcs.some(
    (upc: string) =>
      upc === matchingBarcode || Number(upc) === Number(matchingBarcode),
  );
}

export function getPriceFromNSC2(upc: string) {
  let code = upc;
  if (code.length > 12) code = code.substring(1, code.length);
  if (code?.length > 11) code = code.substring(0, code?.length - 1);
  return Number(code?.substring(code?.length - 4));
}

export function getPrefixFromNSC2(upc: string) {
  if (!isNSC2(upc)) return upc;
  let code = upc;
  if (code.length > 12) code = code.substring(1, code.length);
  if (code?.length > 11) code = code.substring(0, code?.length - 1);
  return code?.substring(0, code?.length - 5);
}

export function removeLeadingZeroes(str: string) {
  return str.replace(/^0+/, '');
}
